import { render, staticRenderFns } from "./MuralAgenda.vue?vue&type=template&id=4c37fb72&scoped=true"
import script from "./MuralAgenda.vue?vue&type=script&lang=js"
export * from "./MuralAgenda.vue?vue&type=script&lang=js"
import style0 from "./MuralAgenda.vue?vue&type=style&index=0&id=4c37fb72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c37fb72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c37fb72')) {
      api.createRecord('4c37fb72', component.options)
    } else {
      api.reload('4c37fb72', component.options)
    }
    module.hot.accept("./MuralAgenda.vue?vue&type=template&id=4c37fb72&scoped=true", function () {
      api.rerender('4c37fb72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/mural/MuralAgenda.vue"
export default component.exports